import SvgArrow from "../svg/SvgArrow";
import SvgPin from "../svg/SvgPin";
import Button from "./Button";
import {useRouter} from "next/router";
import localized from "../locale/locales";

export default function JobItem({
                                    title,
                                    url,
                                    department,
                                    description,
                                    benefits,
                                    location,
                                    requirements,
                                    active = false,
                                    onClick
                                }) {
    const {locale} = useRouter();
    const {jobs: lang} = localized[locale];

    return (
        <article className="w-full max-w-4xl">
            <header
                className={`flex justify-between items-center gap-6 md:gap-4 shadow-faq bg-white ${!active ? 'mouse-hover:bg-gray-50' : ''} py-5 md:py-7 px-5 md:px-10 rounded-6 cursor-pointer transition-all duration-200 ease-linear`}
                onClick={onClick}>
                <h3 className="text-lg">
                    {title}
                </h3>
                <div className="flex items-center gap-6">
                    {location && (
                        <div
                            className="inline-flex items-center gap-2 bg-black text-white rounded-full px-4 py-1.5 text-sm font-semibold">
                            <SvgPin width={16}/>
                            {location}
                        </div>
                    )}
                    <div className="text-0">
                        <SvgArrow height={30}
                                  className={`transform transition-transform duration-300 ${active ? 'rotate-180' : ''}`}
                                  id="job-item"
                        />
                    </div>
                </div>
            </header>

            <div className={`accordion accordion-0 accordion-lg ${active ? 'accordion-open' : ''}`}>
                <div className="pt-6 px-5 md:px-10 text-sm leading-180 flex flex-col gap-6 job-item">
                    <div className="flex flex-col gap-4" dangerouslySetInnerHTML={{__html: description}}/>

                    <div>
                        <h4 className="font-bold">{lang.benefits}:</h4>
                        <div className="flex flex-col gap-4" dangerouslySetInnerHTML={{__html: benefits}}/>
                    </div>

                    <div>
                        <h4 className="font-bold">{lang.requirements}:</h4>
                        <div className="flex flex-col gap-4" dangerouslySetInnerHTML={{__html: requirements}}/>
                    </div>

                    <div className="pb-6 text-center">
                        <Button label={lang.cta}
                                target="_blank"
                                href={url}
                                rel="nofollow noreferrer"
                        />
                    </div>
                </div>
            </div>
        </article>
    )
}
